export default __webpack_public_path__ + "static/media/04en.d69883e0.mp3";